import {
    ENCRYPTED_CARD_NUMBER,
    ENCRYPTED_EXPIRY_DATE,
    ENCRYPTED_SECURITY_CODE,
    ENCRYPTED_PWD_FIELD
} from '../../../internal/SecuredFields/lib/constants';

const TAX_NUMBER = 'taxNumber';
const HOLDER_NAME = 'holderName';
const SSN_FIELD = 'socialSecurityNumber';

export const CREDIT_CARD = [ENCRYPTED_CARD_NUMBER, ENCRYPTED_EXPIRY_DATE, ENCRYPTED_SECURITY_CODE];

export const CREDIT_CARD_NAME_TOP = [HOLDER_NAME, ENCRYPTED_CARD_NUMBER, ENCRYPTED_EXPIRY_DATE, ENCRYPTED_SECURITY_CODE];

export const CREDIT_CARD_NAME_BOTTOM = [ENCRYPTED_CARD_NUMBER, ENCRYPTED_EXPIRY_DATE, ENCRYPTED_SECURITY_CODE, HOLDER_NAME];

const KCP_FIELDS = [TAX_NUMBER, ENCRYPTED_PWD_FIELD];
export const KCP_CARD = CREDIT_CARD.concat(KCP_FIELDS);
export const KCP_CARD_NAME_TOP = CREDIT_CARD_NAME_TOP.concat(KCP_FIELDS);
export const KCP_CARD_NAME_BOTTOM = CREDIT_CARD_NAME_BOTTOM.concat(KCP_FIELDS);

export const SSN_CARD = CREDIT_CARD.concat([SSN_FIELD]);
export const SSN_CARD_NAME_TOP = CREDIT_CARD_NAME_TOP.concat([SSN_FIELD]);
export const SSN_CARD_NAME_BOTTOM = CREDIT_CARD_NAME_BOTTOM.concat([SSN_FIELD]);
